<template>
    <button class="c-version-control" @click.prevent="switchBranch">
        v{{version}} : <i>{{branch}}</i>
        <span class="btn-switch"></span>
    </button>
</template>

<script>
import {socketStore} from "@/stores/socket";

export default {
    name : "VersionControl",

    data() {
        return {
            version: "",
            branch : ""
        };
    },

    created() {
        // eslint-disable-next-line no-undef
        this.version = __APP_VERSION__;

        socketStore().on("GET_BRANCH", this.onGetBrench);
        socketStore().emit("GET_BRANCH");
    },

    methods: {
        onGetBrench(data) {
            this.branch = data.branch;
        },

        switchBranch() {
            this.branch = this.branch === "master" ? "stage" : "master";
            socketStore().emit("SET_BRANCH", {branch : this.branch});
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-version-control {
        font-size : .9em;
        margin-right : 1rem;
        display : flex;
        align-items: center;
        background-color: transparent;
        border : none;
        text-decoration: underline;
        cursor : pointer;
    }

    .btn-switch {
        background-image : url('/img/branch.svg');
        width : 1.5rem;
        height : 1.5rem;
        border : none;
        background-size: 50%;
        background-repeat: no-repeat;
        background-position: center;
    }
</style>